// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2xRKo","footer":"ModalInfo_footer__3tbob"};